import type { Variants } from 'framer-motion';

import type { TModalSizes } from './modal.interface';

export * from './modal.component';

const containerVariants: Variants = {
  enter: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};

const modalSizeClass: { [key in TModalSizes]: string } = {
  lg: 'co-max-w-screen-lg',
  md: 'co-max-w-screen-md',
  sm: 'co-max-w-screen-sm',
  xl: 'co-max-w-screen-xl',
  small: 'co-max-w-screen-small'
};

function getSizeModal(value: TModalSizes): string {
  return modalSizeClass[value];
}

const createCommonStyle = (isMobile: boolean, rounded: boolean): string => {
  const mobileClass = isMobile ? 'co-mx-auto co-mt-auto' : 'co-m-auto';
  const roundedClass = rounded ? 'co-rounded-[4px]' : 'co-rounded-none';
  return `co-bg-common-white co-overflow-hidden ${mobileClass} ${roundedClass}`;
};

const DEFAULT_INITIAL_ANIMATE = {
  y: '100vh',
  opacity: 0
};

const DEFAULT_ANIMATE = {
  y: '0vh',
  opacity: 1
};

const DEFAULT_ANIMATION = {
  initial: DEFAULT_INITIAL_ANIMATE,
  animate: DEFAULT_ANIMATE,
  exit: DEFAULT_INITIAL_ANIMATE
};

export {
  containerVariants,
  createCommonStyle,
  DEFAULT_ANIMATION,
  getSizeModal
};
